import { render, staticRenderFns } from "./UIInput.vue?vue&type=template&id=b6b3dc4e&scoped=true"
import script from "./UIInput.vue?vue&type=script&lang=js"
export * from "./UIInput.vue?vue&type=script&lang=js"
import style0 from "./UIInput.vue?vue&type=style&index=0&id=b6b3dc4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b3dc4e",
  null
  
)

export default component.exports